import type { Bundle } from '../types'

/**
 * Guide utilisateur : titres de section, sommaire, étiquettes du schéma.
 *
 * La prose du guide ne passe pas par ce catalogue : treize sections de texte
 * suivi, avec des liens vers les écrans et des passages en gras, se relisent
 * mal découpées en centaines de clés. Elle vit dans deux fichiers jumeaux,
 * `components/guide/sections.fr.tsx` et `sections.en.tsx`, qui rendent le même
 * JSX dans chaque langue.
 */
export const guide = {
  'guide.desc': {
    fr: 'Comment lire chaque écran, qui peut faire quoi, et les comportements qui surprennent sans être des pannes.',
    en: 'How to read each screen, who can do what, and the behaviours that surprise without being faults.',
  },
  'guide.toc': { fr: 'Sommaire du guide', en: 'Guide contents' },
  'guide.tocTitle': { fr: 'Sur cette page', en: 'On this page' },

  // Titres de section — partagés par le sommaire et les deux jeux de prose.
  'guide.s.purpose': { fr: 'À quoi sert cet outil', en: 'What this tool is for' },
  'guide.s.start': { fr: 'Premiers pas', en: 'Getting started' },
  'guide.s.menu': { fr: 'Se repérer dans le menu', en: 'Finding your way around the menu' },
  'guide.s.overview': { fr: "Vue d'ensemble", en: 'Overview' },
  'guide.s.merchants': { fr: 'Marchands', en: 'Merchants' },
  'guide.s.impersonation': { fr: 'Usurpation de marques', en: 'Brand impersonation' },
  'guide.s.undeclared': { fr: 'Marchands non déclarés', en: 'Undeclared merchants' },
  'guide.s.ads': { fr: 'Détection pubs', en: 'Ad detection' },
  'guide.s.betting': { fr: 'Paris & jeux', en: 'Betting & gambling' },
  'guide.s.triage': { fr: 'Traiter une détection', en: 'Handling a detection' },
  'guide.s.configuration': { fr: 'Configuration', en: 'Configuration' },
  'guide.s.administration': { fr: 'Administration', en: 'Administration' },
  'guide.s.roles': { fr: 'Ce que chaque rôle peut faire', en: 'What each role can do' },
  'guide.s.beforeReporting': {
    fr: 'À savoir avant de signaler un problème',
    en: 'Before you report a problem',
  },

  // Schéma du circuit de traitement. Les étiquettes sont du texte dans le SVG.
  'guide.flow.aria': {
    fr: "Circuit de traitement d'une détection, de Nouveau à Archivé",
    en: 'Triage path of a detection, from New to Archived',
  },
  'guide.flow.reopen': { fr: 'réouverture possible', en: 'can be reopened' },
  'guide.flow.reasonRequired': { fr: 'motif écrit obligatoire', en: 'written reason required' },
  'guide.flow.caption': {
    fr: "Les flèches pleines sont les chemins ordinaires. En pointillé : un dossier archivé, comme un faux positif, peut toujours être remis à l'examen.",
    en: 'Solid arrows are the ordinary paths. Dashed: an archived case, a false positive included, can always be put back under review.',
  },
} satisfies Bundle
